<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <p class="page-header lead">
            <i class="fa fa-user"></i> Добро пожаловать, {{ fullnameFromToken }}
          </p>
        </div>
      </div>
      <div class="row">
        <div
          v-for="card in cards"
          :key="card.link"
          v-if="userHasPermission(card)"
          class="col-lg-3 col-md-6"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <div class="row">
                <div class="col-xs-3">
                  <i :class="`fa fa-4x ${card.icon}`"></i>
                </div>
                <div class="col-xs-9 text-right">
                  <div>{{ card.label }}</div>
                </div>
              </div>
            </div>
            <router-link :to="card.link">
              <div class="panel-footer">
                <span class="pull-left">Подробнее</span>
                <span class="pull-right"
                  ><i class="fa fa-arrow-circle-right"></i
                ></span>
                <div class="clearfix"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mainPage } from "@/user/constants";
import { useRoleIdentifier, useTokenPayload } from "@/_shared/mixins";
export default {
  mixins: [useRoleIdentifier, useTokenPayload],
  data() {
    return {
      cards: mainPage.cards,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/user/pages/MainPage.vue